import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { Grid } from '@adc/ui-adc'
import Ribbon from './ribbon'
import styles from './styles.scss'
import RightRibbon from './rightRibbon'
const cx = classnames.bind(styles)

export default class Container extends React.Component {
  static propTypes = {
    left: PropTypes.node,
    ribbonColor: Ribbon.propTypes.color,
    right: PropTypes.node,
    rightRibbon: RightRibbon,
  }

  render() {
    const { left, right, ribbonColor, rightRibbon } = this.props
    return (
      <div className={cx('container')}>
        {rightRibbon}
        <Grid
          as='section'
          centered
          className={cx('bid-banner')}
          data-elm-id='bid_banner'
          id='bid_banner'
          stretched
        >
          <Grid.Column
            mobile={16}
            tablet={right ? 10 : 16}
            computer={right ? 10 : 16}
          >
            <Ribbon
              containerClassName={cx('left')}
              data-elm-id='left'
              color={ribbonColor}
            >
              <div className={cx('left-content')}>{left}</div>
            </Ribbon>
          </Grid.Column>
          {right && (
            <Grid.Column mobile={16} tablet={6} computer={6}>
              <div className={cx('right')} data-elm-id='right'>
                {right}
              </div>
            </Grid.Column>
          )}
        </Grid>
      </div>
    )
  }
}

export const MarginSection = ({
  left,
  right,
  containerClassName,
  children,
  ...rest
}) => (
  <div
    className={cx(
      'margin-section',
      left && 'margin-left',
      right && 'margin-right',
      containerClassName
    )}
    {...rest}
  >
    {children}
  </div>
)

MarginSection.propTypes = {
  children: PropTypes.node,
  containerClassName: PropTypes.string,
  left: PropTypes.bool,
  right: PropTypes.bool,
}

export const LeftMarginSection = props => <MarginSection left {...props} />
